var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgGuestPassengerIndicator(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#0072F9"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.375 8.292a2.445 2.445 0 00-.318-.67c-.133-.2-.293-.37-.48-.512a1.936 1.936 0 00-.638-.318 2.657 2.657 0 00-.784-.111c-.508 0-.96.127-1.358.383-.397.255-.709.63-.937 1.126-.224.493-.337 1.093-.337 1.8 0 .715.113 1.32.337 1.815.225.495.537.873.937 1.131.4.255.865.383 1.394.383.48 0 .896-.092 1.247-.277.354-.184.626-.446.817-.785.19-.341.286-.741.286-1.2l.388.06h-2.567V9.778H14.2v1.136c0 .81-.173 1.51-.517 2.1a3.533 3.533 0 01-1.422 1.367c-.604.317-1.296.476-2.078.476-.87 0-1.635-.196-2.294-.587-.656-.394-1.168-.952-1.537-1.676-.367-.726-.55-1.588-.55-2.585 0-.763.108-1.445.323-2.045.219-.6.524-1.11.914-1.528a3.89 3.89 0 011.376-.96 4.38 4.38 0 011.718-.333c.523 0 1.01.077 1.463.231.452.151.854.367 1.205.647.354.28.645.612.872.997.228.384.377.81.448 1.274h-1.745z",
    fill: "#fff"
  })));
}
export default SvgGuestPassengerIndicator;